import {ReactNode} from 'react';
import classNames from 'classnames';
import I18nProvider from '../I18nProvider';
import {primaryGreen, white} from '../../styles/colors';

export interface ChatBotMessageProps {
  children: ReactNode;
  className?: string;
}

export const ChatBotMessageComponent = ({children, className}: ChatBotMessageProps) => {
  return (
    <div
      className={classNames('rcb-bot-message rcb-bot-message-entry', className)}
      style={{
        backgroundColor: white,
        color: primaryGreen,
        border: '1px solid',
        borderColor: primaryGreen,
        maxWidth: '100%',
        marginLeft: 0,
        marginRight: 0,
        textAlign: 'inherit',
      }}
    >
      {children}
    </div>
  );
};

export const ChatBotMessage = (props: ChatBotMessageProps) => (
  <I18nProvider>
    <ChatBotMessageComponent {...props} />
  </I18nProvider>
);